import steps from './steps/stepsSlice';
import vehicleId from './vehicleId/vehicleIdSlice';
import listingType from './listingType/listingTypeSlice';
import udsLeadGate from './leadGate/leadGateSlice';
import paymentsInfo from './paymentsInfo/paymentsInfoSlice';

export default {
	steps,
	vehicleId,
	listingType,
	udsLeadGate,
	paymentsInfo
};
